<template>
  <div class="p-6 flex flex-col gap-8 description-color">
    <AppDataProperty
      contentId="platformSubscriptions"
      @dataAvailable="
        data => {
          if (!data?.metaData?.subscriptions) return
          options = data?.metaData?.subscriptions
          this.trySelectDefaultOption()
        }
      "
      isComponent
    />
    <div class="font-bold text-white text-xl text-center">
      {{ $t('transactions.subscriptionOptionSelector.title') }}
    </div>

    <div class="grid grid-cols-2 gap-4 max-h-[50svh] overflow-auto">
      <div v-for="(option, i) in options" :key="i">
        <div
          class="h-[12rem] flex flex-col rounded-2xl ripple overflow-hidden duration-300 delay-100 relative"
          @click="selectSubscription(option)"
          :style="{
            background:
              option.platformId === selectedOption?.platformId
                ? `var(--colors-primary-700)`
                : `linear-gradient(to bottom, ${colors[option.platformId]?.join(', ')})`,
          }"
        >
          <div class="h-[8rem] w-full overflow-hidden relative">
            <img
              :src="option.image"
              class="w-full h-full object-contain p-4 pb-0"
              alt=""
            />
          </div>
          <div class="h-[3rem] flex flex-col items-center justify-center">
            <div class="text-center">{{ option.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="buttonComponent mt-4" @click="confirmSelectedOption">
      {{ $t('transactions.subscriptionOptionSelector.continue') }}
    </div>
  </div>
</template>

<script>
import AppDataProperty from '@/components/appData/AppDataProperty.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PlatformSubscriptionOptionSelector',
  components: {
    AppDataProperty,
  },
  props: {
    defaultOptionId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      eventsIds: [],
      colors: {
        ['netflix']: ['#221F1F', '#3A1E1E'], // Noir Netflix + nuance de rouge
        ['prime-video']: ['#0A3557', '#0E4A7A'], // Bleu foncé + nuance de bleu clair
        ['disney-plus']: ['#000435', '#0A1A5C'], // Bleu foncé + nuance de bleu Disney+
        ['crunchyroll']: ['#000000', '#1A0D00'], // Noir + nuance d'orange
        ['spotify']: ['#191414', '#1E2A1E'], // Noir Spotify + nuance de vert
        ['nordvpn']: ['#0D1C3D', '#1A2E5C'], // Bleu foncé + nuance de bleu NordVPN
        ['privatevpn']: ['#000000', '#1A0D00'], // Noir + nuance d'orange
        ['cyberghost']: ['#000000', '#1A1400'], // Noir + nuance de jaune/orange
        ['adn']: ['#000000', '#1A0000'], // Noir + nuance de rouge
        ['chatgpt']: ['#0EA982', '#0EA982'], // Noir + nuance de rouge
      },
      options: [],
      selectedOption: {},
    }
  },
  mounted() {},
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    trySelectDefaultOption() {
      if (!this.defaultOptionId) return
      if (this.selectedOption.id) return
      const matchingOption = this.options.find(
        option => option.platformId == this.defaultOptionId,
      )
      if (!matchingOption) return
      this.selectSubscription(matchingOption)
      this.confirmSelectedOption()
    },
    selectSubscription(option) {
      this.selectedOption = option
    },
    confirmSelectedOption() {
      if (!this.selectedOption.id) {
        this.$Events.dispatchEvent('toast_notification', {
          title: this.$t(
            'transactions.subscriptionOptionSelector.optionSelectionRequiredNotifTitle',
          ),
          body: this.$t(
            'transactions.subscriptionOptionSelector.optionSelectionRequiredNotifBody',
          ),
        })
        return
      }
      this.$emit('optionSelected', {
        ...this.selectedOption,
        gradient: this.colors[this.selectedOption.platformId],
      })
    },
    selectOptionAndConfig(option) {
      return {
        ...option,
        gradient: this.colors[option.platformId],
      }
    },
  },
})
</script>
